import axiosInstance from "@/api/axiosInstance";

export interface ScheduledReportFilters {
  callType?: string;
  rubricId?: number;
  teamId?: number;
  startDate?: string;
  endDate?: string;
}

export interface ScheduledReportFormData {
  name: string;
  frequency: "daily" | "weekly" | "monthly";
  recipients: string[];
  status: "active" | "paused";
  filters?: ScheduledReportFilters | null;
}

export interface ScheduledReportItem {
  id: number;
  uuid: string;
  name: string;
  frequency: string;
  recipients: string[];
  status: string;
  filters: ScheduledReportFilters | null;
  createdByName: string | null;
  lastSentAt: string | null;
  nextRunAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export const fetchScheduledReports = async () => {
  const response = await axiosInstance.get("/api/private/scheduled-reports");
  return response.data;
};

export const createScheduledReport = async (data: ScheduledReportFormData) => {
  const response = await axiosInstance.post(
    "/api/private/scheduled-reports/create",
    data,
  );
  return response.data;
};

export const updateScheduledReport = async (
  uuid: string,
  data: ScheduledReportFormData,
) => {
  const response = await axiosInstance.put(
    `/api/private/scheduled-reports/${uuid}/update`,
    data,
  );
  return response.data;
};

export const deleteScheduledReport = async (uuid: string) => {
  const response = await axiosInstance.delete(
    `/api/private/scheduled-reports/${uuid}/delete`,
  );
  return response.data;
};
